import { Injectable } from '@angular/core';
import { DocumentGedApiService } from '@core-lib/modules/document-ged/services/document-ged-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import * as featureActions from './actions';
@Injectable()
export class AlfrescoDocumentsStoreEffects {
	constructor(private actions$: Actions, private documentGedApiService: DocumentGedApiService) {}

	coordonneesBancairesDocsRequest$ = createEffect(() =>
		this.actions$.pipe(
			ofType(featureActions.LoadCoordonneesBancairesDocsRequest),
			switchMap(action =>
				this.documentGedApiService.getCBDocuments(action?.operationId, action?.coordonneesBancaireId, action?.compteId).pipe(
					switchMap(documents => [featureActions.LoadCoordonneesBancairesDocsSuccess({ entity: documents })]),
					catchError(error => of(featureActions.LoadCoordonneesBancairesDocsFailure({ error })))
				)
			)
		)
	);
}
